import React from 'react';
import { NavLink } from 'react-router-dom';
import './SubLinks.css';

function AboutLinks() {
  return (
    <div className='links'>
      <ul className='sub-items'>
      <li className='sublink-header'>About</li>
        <li>
        <NavLink to='/about/leadership' className={({ isActive }) => (isActive ? "link-active" : "sub-link")}>Leadership</NavLink>
        </li> 
        <li>
        <NavLink to='/about/history' className={({ isActive }) => (isActive ? "link-active" : "sub-link")}>History</NavLink>
        </li>
        <li>
        <NavLink to='/about/gospel' className={({ isActive }) => (isActive ? "link-active" : "sub-link")}>Gospel</NavLink>
        </li>
        <li>
        <NavLink to='/about/statement-of-faith' className={({ isActive }) => (isActive ? "link-active" : "sub-link")}>Statement of Faith</NavLink>
        </li>
      </ul>
    </div>
  )
}

export default AboutLinks
